export default "__VITE_ASSET__DzWFsipe__"